<template>
<img class="odr-pic" :style="`width: ${width} !important; max-width: ${maxWidth} !important; min-width: ${minWidth} !important`">
</template>
<script>
import '../styles/pic.scss'

export default {
    props: {
        width: {
            default: 'auto',
            _descr: 'Set width of image',
        },
        maxWidth: {
            default: 'none',
            _descr: 'Set max-width of image',

        },
        minWidth: {
            default: 'none',
            _descr: 'Set min-width of image',

        },
    },
}
</script>
